export const grey = '#595850'
export const red = '#F03232'

// Single site-wide page colour, taken from the homepage palette (the 'cream'
// theme in themes.js). Every page sits on this — including the footer — so
// nothing reads as a separate colour block. Change it here and it moves
// everywhere.
export const pageBackground = '#FAF9F5'
export const pageBackgroundRgb = 'rgb(250, 249, 245)'



// WEBPACK FOOTER //
// ./src/styles/colors.js